var _title, _desc, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWarning = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "5E8E4C8C-F42F-4379-A93C-FF7D224A97CB")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home_Sem-opcao-desbloqueio-do-cartao",
    transform: "translate(-711.000000, -179.000000)",
    fill: "#E71037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "information",
    transform: "translate(711.000000, 179.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C4.486,0 0,4.48606061 0,10.0000606 C0,15.5140606 4.486,20 10,20 C15.514,20 20,15.5140606 20,10.0000606 C20,4.48606061 15.514,0 10,0 Z M10,18.1818182 C5.48848485,18.1818182 1.81818182,14.5115152 1.81818182,10.0000606 C1.81818182,5.48860606 5.48848485,1.81818182 10,1.81818182 C14.5115152,1.81818182 18.1818182,5.48860606 18.1818182,10.0000606 C18.1818182,14.5115152 14.5114545,18.1818182 10,18.1818182 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,4 C8.67288458,4 8,4.6732 8,5.500675 C8,6.3274 8.67288458,7 9.5,7 C10.3271154,7 11,6.3274 11,5.500675 C11,4.6732 10.3271154,4 9.5,4 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,9 C9.44773333,9 9,9.39176667 9,9.875 L9,15.125 C9,15.6082333 9.44773333,16 10,16 C10.5522667,16 11,15.6082333 11,15.125 L11,9.875 C11,9.39176667 10.5522667,9 10,9 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning.3f44cfa9.svg";
export { ForwardRef as ReactComponent };